<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="clipboard-list" />
          {{ $t('order') }}
        </h1>
      </div>
    </div>
    <order-list></order-list>
  </main>
</template>

<script>
import OrderList from '@/views/ecommerce/OrderList.vue'

export default {
  components: { OrderList },
  data() {
    return {}
  },
  i18n: {
    messages: {
      en: {
        order: 'Order'
      },
      vi: {
        order: 'Đơn hàng'
      }
    }
  }
}
</script>